import styled from "styled-components";
import { Card } from "../ModalSolicitarProfissional/styled";

export { Overlay } from "../ModalSolicitarProfissional/styled";

// Mesmo cartão do pedido de perfil Profissional; só entram o bloco do contato e o
// resumo do que foi enviado.
export const CardPatrocinio = styled(Card)`
  .contato{
    margin-top: 4px;
    padding: 10px 12px;
    border-radius: 8px;
    background: #F4F6F4;
    border: 1px solid #E1E3E6;
    font-size: 12px;
    line-height: 150%;
    color: #4D4F50;

    strong{ color: #111; }
    a{ color: var(--primary-color); font-weight: 600; }
  }

  .enviado{
    margin: 12px 0 0;
    padding: 0;
    list-style: none;
    font-size: 13px;
    line-height: 160%;
    color: #4D4F50;

    li{ overflow-wrap: anywhere; }
    b{ color: #111; }
  }

  .form-group + .form-group{ margin-top: 0; }
`;
